import React from "react";
import moment from "moment";

const SERVICE_LABEL = "Professional Demonstration";

const methodLabel = (method) => {
  if (method === "paypal") return "PayPal";
  if (method === "square" || method === "squareup") return "Square";
  if (method === "stripe") return "Stripe";
  return method || "";
};

export default function Confirmation({ event, userDetails, timeZoneName }) {
  if (!event) return null;
  const start = moment(`${event.date} ${event.start_time}`, [
    "YYYY-MM-DD HH:mm",
    "YYYY-MM-DD hh:mm A",
  ]);
  const paid = Number(event.price) > 0;
  const languages = Array.isArray(event.languages)
    ? event.languages.join(", ")
    : event.languages;

  return (
    <div className="container se-confirm text-center">
      <div className="se-confirm-check">
        <span>&#10003;</span>
      </div>
      <h3 className="se-confirm-title">Your spot is reserved!</h3>
      <div className="se-confirm-card">
        <p>
          <b>Event:</b> {event.title}
          {languages ? ` (${languages})` : ""}
        </p>
        <p>
          <b>Type:</b> {SERVICE_LABEL}
        </p>
        <p>
          <b>When:</b> {start.format("ddd, MMM D")} &middot; {start.format("hh:mm A")} ({timeZoneName})
        </p>
        <p>
          <b>Paid:</b>{" "}
          {paid
            ? `$${Number(event.price).toFixed(2)} ${event.currency || "USD"}${
                userDetails && userDetails.method
                  ? ` via ${methodLabel(userDetails.method)}`
                  : ""
              }`
            : "Free event"}
        </p>
        <p className="mb-0">
          <b>Confirmation sent to:</b> {userDetails && userDetails.email}
        </p>
      </div>
      <p className="se-muted mt-3">
        Check your email for the meeting link — it may land in spam/junk.
      </p>
      <a className="se-btn-tan se-confirm-continue" href="/">
        Continue
      </a>
    </div>
  );
}
